<template>
  <div class="v-call-container">
    <video ref="localVideo" autoplay muted></video>
    <video ref="remoteVideo" autoplay muted></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mediaConstraints: {
        audio: true,
        video: {
          width: 640,
          height: 480,
        },
      },
      localVideo: null,
      remoteVideo: null,
      signaler: null,
      peerConnection: null,
      role: 'receiver',
      titleStatus: '',
      pingTimeout: null,
    }
  },
  mounted() {
    const configIceServer = { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] };
    this.signaler = new WebSocket('wss://webrtc.t1.msk.finmoll.com:443');
    this.peerConnection = new RTCPeerConnection(configIceServer);

    console.log(this.peerConnection);
    console.log('Refs:', this.$refs);
    // if (this.role === 'receiver') {
    // this.startCall();
    // }

    this.peerConnection.onicecandidate = ({ candidate }) => {
      if (candidate) {
        this.signaler.send(JSON.stringify({ type: 'candidate', candidate }));
      }
    };

    this.peerConnection.onconnectionstatechange = () => {
      console.log('Состояние соединения:', this.peerConnection.connectionState);
    };

    this.peerConnection.oniceconnectionstatechange = () => {
      console.log('ICE состояние:', this.peerConnection.iceConnectionState);
    };

    this.peerConnection.ontrack = (event) => {
      console.log('Получен трек:', event.track, 'поток:', event.streams[0]);
      this.$refs.remoteVideo.srcObject = event.streams[0];
    };

    this.connectToSignalingServer();

    if (this.role === 'caller') {
      console.log('Mounted to caller');
    } else if (this.role === 'receiver') {
      console.log('Mounted to receiver');
      navigator.mediaDevices.getUserMedia(this.mediaConstraints)
        .then((stream) => {
          for (const track of stream.getTracks()) {
            this.peerConnection.addTrack(track, stream);
          }
          this.$refs.localVideo.srcObject = stream;
        })
        .catch(error => {
          console.error('Ошибка доступа к камере у receiver:', error);
        });
    }
  },

  methods: {
    // async startCall () {
    //   try {
    //     const stream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);

    //     for (const track of stream.getTracks()) {
    //       this.peerConnection.addTrack(track, stream);
    //     }

    //     this.$refs.localVideo.srcObject = stream;
    //     console.log('this.localVideo.srcObject', this.localVideo.srcObject);

    //     const offer = await this.peerConnection.createOffer();
    //     await this.peerConnection.setLocalDescription(offer);

    //     this.signaler.send(JSON.stringify({
    //       type: 'offer',
    //       sdp: offer.sdp,
    //     }));

    //     console.log('Offer отправлен');
    //   } catch (err) {
    //     console.error('Ошибка старта звонка:', err.name, err.message);
    //     // Убрать после отладки
    //     if (window.location === 'http://localhost:8080/video_call?role=caller') {
    //       if (err.name === 'NotAllowedError') {
    //         console.error('Доступ к камере запрещён пользователем.');
    //       } else if (err.name === 'NotFoundError') {
    //         console.error('Камера не найдена.');
    //       } else if (err.name === 'NotReadableError') {
    //         console.error('Камера занята другим приложением.');
    //       } else {
    //         console.error('Неизвестная ошибка доступа к камере.');
    //       }
    //     }
    //   }
    // },
    heartbeat() {
      clearTimeout(this.pingTimeout);

      // Use `WebSocket#terminate()`, which immediately destroys the connection,
      // instead of `WebSocket#close()`, which waits for the close timer.
      // Delay should be equal to the interval at which your server
      // sends out pings plus a conservative assumption of the latency.

      this.pingTimeout = setTimeout(() => {
        console.log('Соединение разорвано. Закрываем...');
        this.signaler.close();
      }, 30000 + 1000);
    },
    connectToSignalingServer () {
      this.signaler.onopen = () => {
        console.log('Подключён к сигнальному серверу..');
        this.heartbeat.call(this.signaler);
      };

      this.signaler.onmessage = async event => {
        let data = event.data;
        if (data instanceof Blob) {
          data = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(data);
          });
        }
        const message = JSON.parse(data);
        console.log('{message}')
        console.log({message})

        if (message.type === 'offer') {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
          const answer = await this.peerConnection.createAnswer();
          await this.peerConnection.setLocalDescription(answer);
          this.signaler.send(JSON.stringify(answer));
          try {
            const stream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);
            this.localVideo.srcObject = stream;

            for (const track of stream.getTracks()) {
              this.peerConnection.addTrack(track, stream);
            }

            console.log('Треки добавлены, можно обрабатывать offer');
          } catch (err) {
            console.error('Не удалось получить доступ к медиа:', err);
          }
        }

        if (message.type === 'answer' && this.role === 'caller') {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
        }

        if (message.type === 'candidate') {
          const iceCandidate = new RTCIceCandidate(message.candidate);
          await this.peerConnection.addIceCandidate(iceCandidate);
        }
        if (message.type === 'ping') {
          console.log('Получен ping от сервера..');
          this.heartbeat.call(this.signaler);
        } else {
          console.log('Получено сообщение:', message);
        }
      };

      this.signaler.onclose = () => {
        console.log('Соединение с сигнальным сервером закрыто');
      };
    },
  },
  watch: {
    titleStatus: function () {
      return this.peerConnection?.connectionState === 'connected' ? 'Соединение установлено' : 'Ожидайте звонок';
    }
  }
}
</script>

<style scoped>
.call-container {
  padding: 20px;
}

.videos {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

video {
  width: 400px;
  height: 300px;
  background-color: #000;
  border: 1px solid #ccc;
}

.controls button {
  margin-right: 10px;
}
</style>
